import React, { FC } from 'react';

import { Spinner } from '@common/components/Spinner';
import { JourneyPicker } from '../JourneyPicker';
import SectionContainer from '@common/components/SectionContainer';
import { List } from './List';
import { PageTitle, BodySmallMuted } from '@common/components/Typography';

import { ContentParser } from '@common/components/ContentParser';
import { ListPageProps } from './list.types';
import {
  NotFoundWrapper,
  PageTitleDescriptionWrapper,
  SectionDescription,
} from './ListPage.styles';
import { some } from '@utils/some';
import { pick } from 'lodash';
import { JourneyPickerProps } from '../JourneyPicker/JourneyPicker.types';

export const ListPage: FC<ListPageProps> = ({
  journeyParams,
  onChangeJourneyParams,
  title,
  description,
  items,
  isFetching,
  errorMessage,
  displayWithBriefDescription,
  acceptPromoRateCode,
  hasMoreItems,
  onShowMoreItems,
  journeyPickerProps,
  renderMetadataRow,
}) => {
  // Journey picker shows as a guests picker by default in this component
  // Don't do this if one of the other picker types have been passed
  const showGuestsPickerByDefault = !some(
    Object.values(
      pick(
        journeyPickerProps || ({} as JourneyPickerProps),
        'showCategoriesPicker',
        'showDatesPicker',
        'showSearchInput'
      )
    ),
    (x) => x
  );

  return (
    <>
      <Spinner data-cy="spinner" isActive={isFetching} showDelayMessage />

      <SectionContainer data-cy="section-container" zIndex={10}>
        <JourneyPicker
          data-cy="journey-picker"
          showGuestsPicker={showGuestsPickerByDefault}
          onChange={onChangeJourneyParams}
          acceptPromoRateCode={acceptPromoRateCode}
          {...(journeyPickerProps || {})}
          journeyParams={journeyParams}
        />
      </SectionContainer>

      <SectionContainer zIndex={5}>
        <PageTitleDescriptionWrapper data-cy="page-title-description">
          <PageTitle data-cy="page-title">{title}</PageTitle>
          <SectionDescription data-cy="section-description">
            {description && <ContentParser text={description} />}
          </SectionDescription>
        </PageTitleDescriptionWrapper>

        <List
          data-cy="list"
          items={items}
          hasMoreItems={hasMoreItems}
          onShowMoreItems={onShowMoreItems}
          renderMetadataRow={renderMetadataRow}
          displayWithBriefDescription={displayWithBriefDescription}
        />

        {!some(items) && errorMessage && (
          <NotFoundWrapper data-cy="not-found-wrapper">
            {errorMessage.title}
            <br />
            <BodySmallMuted data-cy="error-message">{errorMessage.message}</BodySmallMuted>
          </NotFoundWrapper>
        )}
      </SectionContainer>
    </>
  );
};
